import $ from 'jquery';
import { Drilldown } from 'foundation-sites';
import { Dropdown } from 'foundation-sites';

/**
 * Mobile Menu
 */

// Élements & Variables
const toggleBtn = document.querySelector('.js-menu-toggle');

// Au click sur le bouton
if (toggleBtn) {

  toggleBtn.addEventListener('click', (ev) => {
    ev.preventDefault();
    document.body.classList.toggle('menu-open')
  });

}

// window.addEventListener('load', function(event) {
//
//   // ### DrillDown Menu
//   // Settings
//   const drillDownEl = $('.js-menu .navigation > ul.menu');
//   const drillDownBack = drillDownEl.attr('data-back');
//   const drillDownOptions = {
//     backButton: `<li class="js-drilldown-back"><a class="drilldown__link drilldown__link--back" tabindex="0"></a></li>`,
//     closeOnClick: true,
//     parentLink: true
//     //scrollTop: true,
//     //autoHeight: true,
//     //animateHeight: true
//   };
//   // Init
//   const drillDownInstance = new Drilldown(drillDownEl, drillDownOptions);
//
// });

